import React, {Component} from 'react'
import {Table} from 'antd'
import request from '../../utils/request'
import PropTypes from 'prop-types'

class StandardTable extends Component {

    state = {
        data: [],
        loading: false,
        pagination: {
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: [10, 20, 30, 50, 100, 200, 400]
        },
        filters: null,
        sorter: null,
        keyword: null
    };

    componentDidMount() {
        this.fetch()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.keyword !== this.props.keyword) {
            this.setState({
                keyword: nextProps.keyword,
                pagination: {...this.state.pagination, current: 1}
            }, () => {
                this.fetch()
            });
        }
        if (nextProps.url !== this.props.url) {
            this.fetch(nextProps.url)
        }
    }


    fetch = (url) => {
        url = url || this.props.url;
        const {getData} = this.props;
        const {pagination, sorter, keyword} = this.state;
        const filters = {...this.state.filters, ...this.props.filters}
        const method = this.props.requestMethod
        this.setState({
            loading: true
        });
        request({
            url: url,
            method: method,
            [method === 'post' ? 'data' : 'params']: {
                page: pagination.current,
                limit: pagination.pageSize,
                order: sorter ? sorter.field : null,
                sort: sorter ? sorter.order : null,
                keyword: keyword,
                ...filters,
            }
        }).then(({data}) => {
            const pagination = {...this.state.pagination};
            pagination.total = data.total;
            this.setState({
                data: data.data,
                loading: false,
                pagination
            })
            if (getData) {
                getData(data)
            }
        }).catch(() => {
            this.setState({
                loading: false,
            })
        })
    };

    handleTableChange = (pagination, filters, sorter) => {
        const {onChange} = this.props;
        if (onChange) onChange(pagination, filters, sorter);
        this.setState({
            pagination, filters, sorter
        }, () => {
            this.fetch();
        });
    };

    render() {
        let {columns, ...restProps} = this.props;
        if (process.env.NODE_ENV === 'production') {
            columns = columns.filter(item => item.dataIndex !== 'id')
        }
        const defaultRowKey = record => record.id.toString();
        const result = (
            <Table
                {...restProps}
                // rowKey={(record) => record[this.props.rowKey]}
                rowKey={this.props.rowKey ? this.props.rowKey : defaultRowKey}
                columns={columns}
                dataSource={this.state.data}
                pagination={this.state.pagination}
                onChange={this.handleTableChange}
                loading={this.state.loading}
            />
        )

        return result
    }
}

StandardTable.propTypes = {
    rowKey: PropTypes.string,
    url: PropTypes.string,
    columns: PropTypes.array,
    requestMethod: PropTypes.string
};

StandardTable.defaultProps = {
    requestMethod: 'get'
}

export default StandardTable;
